import { Phone, AlertCircle } from "lucide-react";

const ImportantNumbers = () => {
  const contacts = [
    { label: "Property Manager", name: "Mr. Jagadeesh", phone: "99404 86461" },
    { label: "Helpdesk", name: null, phone: "044-4768 5238 / 88709 58926" },
    { label: "24×7 Main Gate Security", name: null, phone: "88708 44505" },
    { label: "Housekeeping In-charge", name: "Ms. Devi", phone: "99621 62870" },
  ];

  return (
    <section id="numbers" className="py-20 sm:py-28 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-4">
          <AlertCircle className="w-8 h-8" />
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight">
            Important Numbers
          </h2>
        </div>
        <p className="text-lg text-white/90 mb-12 max-w-2xl">
          Quick access to essential contacts for residents and emergencies
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {contacts.map((contact, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6 hover:bg-white/15 transition-all"
            >
              <p className="text-sm font-semibold text-white/80 uppercase tracking-wide mb-2">
                {contact.label}
              </p>
              {contact.name && (
                <p className="text-white/90 mb-3">{contact.name}</p>
              )}
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-white/80" />
                <span className="text-2xl font-bold text-white">
                  {contact.phone}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Emergency Info Box */}
        <div className="mt-12 bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg p-6 sm:p-8">
          <p className="text-white/90 text-center">
            <span className="font-bold">In case of emergency,</span> contact the Main Gate Security or Helpdesk immediately. 
            All emergency services are available 24 hours a day, 7 days a week.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ImportantNumbers;
